module.exports = __webpack_public_path__ + "img/BOUTON_ON.7191471b.png";